/**
 * 表紙特集掲載商品選定（CX）画面の特集一覧クラス
 *
 * @export MediumListInfo
 * @class MediumListInfo
 */
export class MediumListInfo {
  constructor(
    // 媒体コード
    public Code: string,
    // 媒体名
    public Name: string,
  ) {}
}
